import { useQuery } from '@tanstack/react-query';
import { getParkingInfo, getCarParkingList, getParkingFee, getAreaInfo } from '@/services/operations/parking';
import { PARKING_QUERY_KEYS } from '@/services/query-keys/parking';
import type { AreaInfoRequest, CarParkingListRequest, ParkingFeeRequest } from '@/services/dto/parking';

/**
 * Hook to get parking information for a specific branch
 */
export const useParkingInfo = (branchCode: string) => {
    return useQuery({
        queryKey: PARKING_QUERY_KEYS.parkingInfo(branchCode),
        queryFn: () => getParkingInfo(branchCode),
        enabled: !!branchCode,
    });
};

/**
 * Hook to get car parking list by site code and car number
 */
export const useCarParkingList = (request: CarParkingListRequest) => {
    return useQuery({
        queryKey: PARKING_QUERY_KEYS.carParkingList(request),
        queryFn: () => getCarParkingList(request),
        enabled: !!(request.siteCode && request.carNumber),
    });
};

/**
 * Hook to get parking fee for a specific car
 */
export const useParkingFee = (request: ParkingFeeRequest) => {
    return useQuery({
        queryKey: PARKING_QUERY_KEYS.parkingFee(request),
        queryFn: () => getParkingFee(request),
        enabled: !!(request.siteCode && request.licensePlate && request.inGate && request.inDate && request.inTime),
    });
};

/**
 * Hook to get area info for a specific car
 */
export const useAreaInfo = (request: AreaInfoRequest) => {
    return useQuery({
        queryKey: PARKING_QUERY_KEYS.areaInfo(request),
        queryFn: () => getAreaInfo(request),
        enabled: !!(request.siteCode && request.licensePlate),
    });
};
